/*
 * @Description:
 * @Date: 2021-02-01 19:17:25
 */

import request from '@/utils/request';
const baseUrl = '/rest/channel/pc';

export const channelMenuList = data =>
  request({
    url: `${baseUrl}/channelMenu/channelMenuList`,
    method: 'post',
    data
  });
export const querychannelCourseList = data =>
  request({
    url: `${baseUrl}/channelCourse/querychannelCourseList`,
    method: 'post',
    data
  });
// 是否展示跳转医生汇
export const querySaasAndYsh = data =>
  request({
    url: `${baseUrl}/channelCourse/querySaasAndYsh`,
    method: 'post',
    data
  });
// saas跳转YSH使用
export const saasJumpYsh = data =>
  request({
    url: `${baseUrl}/channelCourse/saasJumpYsh`,
    method: 'post',
    data
  });
